import React, { FC, MouseEvent } from 'react'
import { IconButton, FormLabel, BoxProps } from '@chakra-ui/core'

export interface Props extends BoxProps {
  value?: number
  name: string
  minusAction: (event: MouseEvent<HTMLButtonElement>) => void
}

export const MinusAndText: FC<Props> = ({ value = 0, name, minusAction }) => {
  return (
    <>
      <IconButton
        aria-label={`${name}-product-minus`}
        icon="minus"
        variant="outline"
        variantColor="primary"
        bg="transparent"
        borderColor="transparent"
        onClick={minusAction}
        fontSize="6"
        w="3.2rem"
        h="3.2rem"
        isDisabled={value <= 0}
      />
      <FormLabel
        aria-label="quantity"
        as="title"
        flex="1"
        textAlign="center"
        padding="0"
        fontSize="1.4rem"
        fontFamily="body"
      >
        {value}
      </FormLabel>
    </>
  )
}
